import type { KeyboardEvent } from 'react';

import { focusElement } from './FocusElement';
import { getMoreToolbarStartAndEndButtons } from './GetMoreToolbarStartAndEndButtons';
import { getStartAndEndButtons } from './GetStartAndEndButtons';
import { isMovingFromElement } from './IsMovingFromElement';

type moreToolbarFocusHandlererParams = {
  e: KeyboardEvent<HTMLDivElement>;
  firstButtonDataHook: string;
  moreButton: HTMLButtonElement;
  moreModalFirstButtonDataHook: string;
  moreModalLastButtonDataHook: string;
};

export const moreToolbarFocusHandlerer = ({
  e,
  firstButtonDataHook,
  moreModalFirstButtonDataHook,
  moreModalLastButtonDataHook,
  moreButton,
}: moreToolbarFocusHandlererParams) => {
  const isTabPressed = e.key === 'Tab';

  if (!isTabPressed) {
    return;
  }

  const isGoingBackwards = e.shiftKey;
  const isGoingForwards = !isGoingBackwards;

  const main = getStartAndEndButtons({
    startButtonDataHook: firstButtonDataHook,
    endButton: moreButton,
  });

  const more = getMoreToolbarStartAndEndButtons({
    startButtonDataHook: moreModalFirstButtonDataHook,
    endButton: moreModalLastButtonDataHook,
  });

  if (isGoingForwards && isMovingFromElement(main.end)) {
    focusElement(more.start, e);
  }

  if (isGoingForwards && isMovingFromElement(more.end)) {
    focusElement(more.start, e);
  }

  if (isGoingBackwards && isMovingFromElement(more.start)) {
    focusElement(main.end, e);
  }
};
